var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClosedLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 40290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04602 7C5.25945 7 3 9.25906 3 12.0457V14.3382C3 17.1249 5.25945 19.3839 8.04602 19.3839H25.049C27.8366 19.3839 30.0948 17.1249 30.0948 14.3382V12.0457C30.0948 9.25906 27.8366 7 25.049 7H8.04602ZM8.7192 9.39098C7.04644 9.39098 5.69089 10.7465 5.69089 12.4184V13.9655C5.69089 15.6375 7.04644 16.993 8.7192 16.993H24.3768C26.0486 16.993 27.4041 15.6375 27.4041 13.9655V12.4184C27.4041 10.7465 26.0486 9.39098 24.3768 9.39098H8.7192Z",
    fill: "#031022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.5481 14.5641C17.3417 14.5641 17.985 13.9208 17.985 13.1272C17.985 12.3337 17.3417 11.6904 16.5481 11.6904C15.7546 11.6904 15.1113 12.3337 15.1113 13.1272C15.1113 13.9208 15.7546 14.5641 16.5481 14.5641Z",
    fill: "#031022"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedLogo);
export default __webpack_public_path__ + "static/media/closedLogo.0c7fc0303185307167a555093d6ab092.svg";
export { ForwardRef as ReactComponent };